import React from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import StudentStudyQualityTable from './StudentStudyQualityTable';
import { StudentStudyQualityListService } from '../../services/CustomerSuccessKpiListService';
import { browserHistory } from 'react-router';
import { get } from 'lodash';

class StudentStudyQualityTableContainer extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['segment', 'distributor']).isRequired,
  };

  constructor(props) {
    super(props);
    StudentStudyQualityListService.load();
  }

  render() {
    return (
      <StudentStudyQualityTable
        loading={
          StudentStudyQualityListService.fetchCurrent.fetching || StudentStudyQualityListService.fetchPrevious.fetching
        }
        values={toJS(
          get(
            StudentStudyQualityListService,
            { segment: 'bySegment', distributor: 'byDistributor' }[this.props.type],
            []
          )
        )}
        feedbackColorRender={StudentStudyQualityListService.getFeedbackColor}
        onSelect={(row) => browserHistory.push(`/kpis/customer-success/${this.props.type}/${row.id}/details`)}
        formatter={StudentStudyQualityListService.getFormattedValue}
      />
    );
  }
}

export default observer(StudentStudyQualityTableContainer);
